import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { type QiankunSubAppConfig } from '@sfvine/main-qiankun';
import useSettingsStore from '../settings';
import { type SubLoaderConfig } from '../settings/types';

export type MenuItemNew = [string, QiankunSubAppConfig];

const useSubAppLoaders = defineStore('sub-app-loaders', () => {
  const settingsStore = useSettingsStore();

  const active = ref<MenuItemNew>();
  const activatedList = ref<string[]>([]);
  const loadingActive = ref<MenuItemNew>();
  const loadingObj = ref<Record<string, boolean | undefined>>({});
  const isLoading = computed(() => loadingActive.value !== undefined && loadingObj.value[loadingActive.value?.[0]])
  
  const isActive = (curName: string) => active.value?.[0] === curName;
  const options = computed(() => {
    const opts: Record<string, SubLoaderConfig> = {};
    (settingsStore.settings.subApps || []).forEach((v: SubLoaderConfig) => {
      const k = v.name;
      opts[k] = {
        ...v,
        name: k,
      };
    });
    return opts;
  });
  const shouldLoadApps = computed(() =>
    Object.entries(options.value).filter(
      ([name, config]) => isActive(name) || (config.keepAlive && activatedList.value.includes(name)),
    ),
  );

  return {
    active,
    activatedList,
    loadingActive,
    loadingObj,
    isLoading,
    isActive,
    options,
    shouldLoadApps
  };
});

export default useSubAppLoaders;
